import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import './FAQSection.scss';

const FAQSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const faqs = [
    {
      question: 'What do I need to post a job?',
      answer: (
        <>
          Just the basics: date, time, location, and pay rate. It’s free to post, and you’re only charged once services are rendered by the Athletic Trainer. If you are looking to post multiple events such as a season calendar or need long-term coverage, our team can help through white-glove service at{' '}
          <a href="mailto:contactus@go4.io" className="faq-email-link">
            contactus@go4.io
          </a>
          .
        </>
      ),
    },
    {
      question: 'Are Athletic Trainers verified?',
      answer: 'Yes. Every AT on Go4 is credentialed and verified before they can work. You’ll see their Board of Certification credential, state licensure, and liability insurance on file—plus, many also hold additional credentials such as SafeSport.',
    },
    {
      question: 'How do I know what pay rate to set?',
      answer: 'You set the rate, but Go4 guides you with market data. We provide recommended ranges based on your location and job type so you can confidently set a competitive rate that attracts top ATs.',
    },
    {
      question: 'Do you choose the Athletic Trainer for me?',
      answer: 'No—you’re in control. ATs apply to your job, and you choose the professional that best fits your needs.',
    },
    {
      question: 'How does payment work?',
      answer: 'Payments are handled securely through Go4. You can pay using a credit card or ACH/bank account, and we take care of paying the AT once the shift is complete. Our service fee covers credential verification, secure payment processing, job marketing, emergency action plan (EAP) distribution, and HIPAA-compliant injury record storage.',
    },
  ];

  const toggleFAQ = index => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <article className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <dl className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}>
              <dt className="faq-question-header">
                <button
                  className="faq-question-button"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={expandedIndex === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span className="faq-question">{faq.question}</span>
                  <span className="faq-icon" aria-hidden="true"></span>
                </button>
              </dt>
              <Collapse isOpen={expandedIndex === index}>
                <dd className="faq-answer" id={`faq-answer-${index}`}>
                  {faq.answer}
                </dd>
              </Collapse>
            </div>
          ))}
        </dl>
      </article>
    </section>
  );
};

export default FAQSection;
